import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageHero, FeatureGrid, ContentSection, SEOContent, CTASection } from '../components/shared';
import { pageHeroImages } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const ueberUnsFeatures = [
  {
    id: '3.1',
    title: 'Unser Kompass',
    description: 'Haltung, Verantwortung und Medizin mit menschlicher Nähe.',
    image: '/images/Hero_Vertrauenssache.webp',
    link: '/ueber-uns/kompass'
  },
  {
    id: '3.2',
    title: 'Das Team',
    description: 'Ärzte und Mitarbeiter – gemeinsam für Ihre Gesundheit.',
    image: '/images/TEAM (12).webp',
    link: '/ueber-uns/team'
  },
  {
    id: '3.3',
    title: 'Das Medicum-Konzept',
    description: 'Hausärzte und Fachärzte unter einem Dach – kurze Wege, schnelle Entscheidungen.',
    image: '/images/Das_Medicum_Prinzip.webp',
    link: '/ueber-uns/medicum'
  },
  {
    id: '3.4',
    title: 'Leistungen & Fragen',
    description: 'Antworten rund um Termin, Behandlung und Organisation.',
    image: '/images/VB00136648_Kopie_opt.webp',
    link: '/ueber-uns/faq'
  }
];

export const UeberUnsPage = () => {
  return (
    <Layout>
      <PageHero
        title="Über uns – Gemeinschaftspraxis Dres. von Bergh im Medicum Diez"
        subtitle="Hausärztliche Medizin mit Haltung, Teamgeist und vernetzter Fachkompetenz."
        backgroundImage={pageHeroImages.ueberUns}
        ctaText="Unser Team kennenlernen"
        ctaLink="/ueber-uns/team"
      />

      <FeatureGrid
        title="Lernen Sie uns kennen"
        features={ueberUnsFeatures}
        columns={4}
      />

      <ContentSection
        title="Medizin als persönliche Begleitung"
        content="Als Gemeinschaftspraxis Dres. von Bergh begleiten wir unsere Patientinnen und Patienten langfristig – vom ersten Gespräch bis zur spezialisierten Diagnostik und Therapie im Medicum Diez."
        image="/images/Medizin_aus_Ueberzeugung.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Hausärzte im Zentrum eines Ärzteverbunds"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Wir verstehen uns als Koordinatoren Ihrer medizinischen Versorgung und arbeiten eng mit den Fachärzten im Medicum Diez zusammen.
            </p>
            <Link to="/ueber-uns/medicum" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
              Das Medicum-Konzept
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        }
        image="/images/Das_Medicum_Prinzip.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <SEOContent
        title="Hausarztpraxis Dres. von Bergh in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh im Medicum Diez steht für persönliche Hausarztmedizin, fachübergreifende Zusammenarbeit und moderne Diagnostik im Rhein-Lahn-Kreis."
      />

      <CTASection
        title="Wir freuen uns auf Sie"
        subtitle="Vereinbaren Sie Ihren Termin und lernen Sie uns persönlich kennen."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default UeberUnsPage;
